import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'
import { ToggleButton } from '@mui/material'

import { theme } from '../../themes/theme'
import { ToggleButtonGroup } from '../styles/ToggleButtonStyles'
import { SpaceBetweenRowContainer, WhiteBGContainer } from '../styles/Containers'
import { BoldMedBodyText } from '../styles/Text'

const FileContainer = styled(WhiteBGContainer)`
  cursor: pointer;
  padding: 10px 15px;
  width: 100%;
  background: ${props => (props.active ? theme.colors.primaryExtraLight : theme.colors.white)};

  word-break: break-word;

  :hover {
    background: ${theme.colors.primaryLight};
  }
`

function DuplicateFile({ id, fileId, filename, active = false, disabled = false, onClickFile = () => {} }) {
  const { setValue, watch } = useFormContext()

  function handleChange(event, newValue) {
    if (newValue !== null) {
      setValue(`${id}.shouldKeep`, newValue)
    }
  }

  const shouldKeep = watch(`${id}.shouldKeep`)

  return (
    <SpaceBetweenRowContainer>
      <FileContainer active={active} onClick={() => onClickFile(fileId)}>
        <BoldMedBodyText>{filename}</BoldMedBodyText>
      </FileContainer>
      <ToggleButtonGroup
        name="keep-remove-button-group"
        id={`${id}.shouldKeep`}
        value={shouldKeep}
        exclusive
        onChange={handleChange}
        aria-label="keep or remove file">
        <ToggleButton value={true} disabled={disabled}>
          Keep
        </ToggleButton>
        <ToggleButton value={false} disabled={disabled}>
          Remove
        </ToggleButton>
      </ToggleButtonGroup>
    </SpaceBetweenRowContainer>
  )
}

DuplicateFile.propTypes = {
  id: PropTypes.string.isRequired,
  fileId: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClickFile: PropTypes.func
}

export default DuplicateFile
